<template>
  <div class="listBox">
    <pageTitle :pageTitle="title">
      <div slot class="color999">
        {{ $t('lang.k_240001') }}
        <span class="msgBlue" @click="openTip">{{ $t('lang.k_240002') }}</span>
      </div>
    </pageTitle>
    <div class="noData" v-if="no_show === true">
      <null-page :text="$t('lang.k_240003')" nullType="noAuth">
        <vh-button class="length152 createBtn" round type="primary" @click="toCreate">
          {{ $t('lang.k_240004') }}
        </vh-button>
        <vh-button
          plain
          v-if="WEBINAR_PES.btn_record && !isEmbed"
          class="length152 transparent-btn"
          round
          type="white-primary"
          @click="toRecord"
        >
          {{ $t('lang.k_240005') }}
        </vh-button>
        <!-- <vh-button type="white-primary" class="length152" round @click="openCheckWord" v-if="$route.params.str">资料库</vh-button> -->
      </null-page>
    </div>
    <template v-if="no_show === false">
      <div v-if="!isDemand" class="operaBlock">
        <vh-button size="medium" type="primary" round @click="toCreate">
          {{ $t('lang.k_240004') }}
        </vh-button>
        <vh-button size="medium" plain class="transparent-btn" round @click="uploadBut">
          {{ $t('lang.k_240006') }}
        </vh-button>
        <vh-button
          v-if="WEBINAR_PES.btn_record && !isEmbed"
          class="transparent-btn"
          size="medium"
          plain
          round
          @click="toRecord"
        >
          {{ $t('lang.k_240005') }}
        </vh-button>
        <vh-button size="medium" class="transparent-btn" round plain @click="settingHandler">
          {{ $t('lang.k_240007') }}
        </vh-button>
        <vh-button
          size="medium"
          class="transparent-btn"
          round
          plain
          :disabled="selectDatas.length < 1"
          @click="deletePlayBack(selectDatas.map(item => item.id).join(','), 1)"
        >
          {{ $t('lang.k_240008') }}
        </vh-button>
        <vh-input
          clearable
          @keyup.enter.native="getSearchList"
          :placeholder="$t('lang.k_240009')"
          autocomplete="off"
          v-clearEmoij
          class="resetRightBrn"
          @clear="getList"
          v-model="keyWords"
        >
          <i class="vh-icon-search vh-input__icon" slot="prefix" @click="getSearchList"></i>
        </vh-input>
      </div>
      <div :class="['tableBox', isDemand === true ? '' : 'recordTableBox']" v-loading="loading">
        <vh-table
          :header-cell-style="{ background: '#f7f7f7', color: '#666', height: '56px' }"
          v-if="isDemand !== ''"
          ref="playBackTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @cell-mouse-enter="handleCellMouseEnter"
          @cell-mouse-leave="handleCellMouseLeave"
        >
          <vh-table-column
            v-if="!isDemand"
            type="selection"
            width="55"
            fixed="left"
          ></vh-table-column>
          <!--
          :width="isBidScreen ? 55 : 52" -->
          <vh-table-column :width="isDemand === true ? 375 : 365" :label="$t('lang.k_240010')">
            <template slot-scope="scope">
              {{ scope.row.date }}
              <div class="content">
                <div class="imageBox">
                  <div class="imageWrap" v-if="scope.row.transcode_status != 1">
                    <p
                      v-if="scope.row.transcode_status == 2"
                      class="statusDesc"
                      @click="reTranscode(scope.row)"
                    >
                      {{ $t('lang.k_240011') }}
                    </p>
                    <p v-else class="statusDesc disabled">
                      {{
                        scope.row.transcode_status == 0 || scope.row.transcode_status == 3
                          ? `${$t('lang.k_240117')}${
                              scope.row.layout != 0 && scope.row.is_union_screen != 1
                                ? scope.row.remake_doc_progress + '%'
                                : ''
                            }`
                          : ''
                      }}
                    </p>
                  </div>
                  <img
                    @click="preview(scope.row)"
                    :src="scope.row.img_url"
                    v-parseImgOss="{ url: scope.row.img_url, type: 'img', default: '1' }"
                    alt=""
                    style="cursor: pointer"
                  />
                  <span
                    v-if="!isDemand || liveDetailInfo.webinar_type == 5 || scope.row.is_rehearsal"
                    class="defaultSign"
                    :class="scope.row.is_rehearsal ? 'isRehearsal' : ''"
                  >
                    <i
                      v-show="!scope.row.is_rehearsal"
                      @click="setDefault(scope.row)"
                      :class="{ active: scope.row.type == 6 }"
                    ></i>
                    {{ scope.row.is_rehearsal ? $t('lang.k_240012') : $t('lang.k_240013') }}
                  </span>
                  <div v-if="scope.row.encrypt_status == 2" class="ps jiami">
                    {{ $t('lang.k_240014') }}
                  </div>
                  <div class="ps jiami_zhezhao" v-if="scope.row.encrypt_status == 1">
                    <div class="ps jiamizhong">{{ $t('lang.k_240015') }}</div>
                  </div>
                </div>
                <div class="info">
                  <vh-tooltip
                    :disabled="!isTextOverflow"
                    placement="top-start"
                    :content="scope.row.name"
                  >
                    <div class="videoName custom-tooltip-content">
                      {{ scope.row.name }}
                    </div>
                  </vh-tooltip>

                  <p class="create-time">{{ scope.row.created_at }}</p>
                  <span v-if="scope.row.ai_moment_tag === 1" class="tag">
                    {{ $t('lang.k_240016') }}
                  </span>
                  <span v-if="scope.row.ai_summary_tag === 1" class="tag">
                    {{ $t('lang.k_240017') }}
                  </span>
                  <span v-if="scope.row.doc_status && WEBINAR_PES['ui.record_chapter']" class="tag">
                    {{ $t('lang.k_240018') }}
                  </span>
                  <span v-if="scope.row.layout != 0 && scope.row.is_union_screen != 1" class="tag">
                    {{ $t('lang.k_240019') }}
                  </span>
                  <span v-if="scope.row.live_subtitle_type > 0" class="tag">
                    <template v-if="scope.row.live_subtitle_type == 1">
                      {{ $t('lang.k_240020') }}
                    </template>
                    <template v-else-if="[3, 4].includes(scope.row.live_subtitle_type)">
                      {{ $t('lang.k_240021') }}
                    </template>
                    <template v-else-if="[2, 5].includes(scope.row.live_subtitle_type)">
                      {{ $t('lang.k_240022') }}
                    </template>
                  </span>
                </div>
              </div>
            </template>
          </vh-table-column>
          <vh-table-column :width="120">
            <template slot-scope="{ column, $index }" slot="header">
              <vh-select
                popper-class="playback-list-popper"
                v-if="!isDemand"
                v-model="recordType"
                @change="typeChange(column, $index)"
              >
                <vh-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></vh-option>
              </vh-select>
              <span v-else>{{ $t('lang.k_240023') }}</span>
            </template>
            <span class="playpackSource" slot-scope="scope">
              {{ soruceTotext(scope.row.source) }}
            </span>
          </vh-table-column>

          <vh-table-column
            :label="$t('lang.k_240024')"
            :width="isBidScreen ? '' : 91"
            show-overflow-tooltip
          >
            <span class="playpackSource" slot-scope="scope">{{ scope.row.duration }}</span>
          </vh-table-column>
          <vh-table-column
            :label="$t('lang.k_240025')"
            width="150"
            v-if="
              WEBINAR_PES['have_watch_record_list'] == 1 &&
              $route.query.type != 5 &&
              $route.query.state != 4
            "
          >
            <template slot-scope="{ column, $index }" slot="header">
              <span>
                {{ $t('lang.k_240025') }}
                <vh-tooltip effect="dark" placement="right" v-tooltipMove>
                  <div slot="content">
                    <p>{{ $t('lang.k_240026') }}</p>
                    <p>{{ $t('lang.k_240027') }}</p>
                    <p>{{ $t('lang.k_240028') }}</p>
                    <p>{{ $t('lang.k_240029') }}</p>
                    <p>{{ $t('lang.k_240030') }}</p>
                  </div>
                  <i class="iconfont-v3 saasicon_help_m icon__max_show"></i>
                </vh-tooltip>
              </span>
            </template>
            <span class="playback_show" slot-scope="scope">
              <vh-select v-model="scope.row.is_display" @change="setDisabled(scope.row)">
                <vh-option :key="1" :label="$t('lang.k_240031')" :value="1"></vh-option>
                <vh-option :key="0" :label="$t('lang.k_240032')" :value="0"></vh-option>
              </vh-select>
            </span>
          </vh-table-column>
          <vh-table-column
            v-if="webinarType == 6"
            :label="$t('lang.k_240033')"
            :width="isBidScreen ? '' : 108"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <router-link
                v-if="scope.row.group_record_num > 0"
                :to="{
                  path: `${isEmbed ? '/embed' : ''}/live/playback/${webinar_id}/group/${
                    scope.row.switch_id
                  }`,
                  query: {
                    is_rehearsal: scope.row.is_rehearsal
                  }
                }"
                style="color: blue"
              >
                {{ scope.row.group_record_num }}
              </router-link>
              <span v-else>-</span>
            </template>
          </vh-table-column>

          <vh-table-column
            v-if="!isDemand"
            :label="$t('lang.k_240034')"
            :width="isBidScreen ? '' : 78"
            show-overflow-tooltip
          >
            <span class="playpackSource" slot-scope="scope">
              {{ layoutFilter(scope.row.layout) }}
            </span>
          </vh-table-column>

          <vh-table-column
            v-if="!isDemand"
            :label="$t('lang.k_240035')"
            :width="isBidScreen ? '' : 110"
            class-name="deltime"
            show-overflow-tooltip
          >
            <span class="playpackSource" slot-scope="scope">{{ $t(scope.row.save_time) }}</span>
          </vh-table-column>

          <vh-table-column
            :width="isBidScreen ? 300 : 286"
            :label="$t('lang.k_240036')"
            fixed="right"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.date }}
              <vh-button type="text" @click="editDialog(scope.row)">
                {{ $t('lang.k_240037') }}
              </vh-button>
              <vh-button v-if="showDownloadButton" type="text" @click="getVideoStatus(scope.row)">
                {{ $t('lang.k_240038') }}
              </vh-button>
              <vh-button type="text" @click="handleAi(scope.row)">
                {{ $t('lang.k_240039') }}
              </vh-button>
              <vh-button
                v-if="scope.row.is_rehearsal"
                type="text"
                @click="deletePlayBack(scope.row.id, 2)"
              >
                {{ $t('lang.k_240040') }}
              </vh-button>
              <vh-button
                v-if="WEBINAR_PES['ui.record_chapter'] && !scope.row.is_rehearsal"
                type="text"
                @click="toChapter(scope.row)"
              >
                {{ $t('lang.k_240018') }}
              </vh-button>
              <vh-button
                type="text"
                v-if="
                  ($route.meta.name == 'recordplayback' || $route.meta.name == 'publishplayback') &&
                  !scope.row.is_rehearsal
                "
                @click="encryption(scope.row)"
              >
                {{ $t('lang.k_240014') }}
              </vh-button>
              <vh-dropdown v-if="!isDemand && !scope.row.is_rehearsal" @command="handleCommand">
                <vh-button type="text">{{ $t('lang.k_240041') }}</vh-button>
                <vh-dropdown-menu style="width: 160px" slot="dropdown">
                  <vh-dropdown-item
                    v-if="
                      WEBINAR_PES['reset_record'] &&
                      !scope.row.layout &&
                      scope.row.is_union_screen != 1
                    "
                    :disabled="scope.row.source == 2"
                    :command="{ command: 'vodreset', data: scope.row }"
                  >
                    {{ $t('lang.k_240019') }}
                  </vh-dropdown-item>
                  <vh-dropdown-item
                    v-if="!scope.row.layout"
                    :command="{ command: 'tailoring', data: scope.row }"
                  >
                    {{ $t('lang.k_240042') }}
                  </vh-dropdown-item>
                  <vh-dropdown-item
                    v-if="WEBINAR_PES['publish_record'] && !scope.row.layout"
                    :command="{ command: 'publish', data: scope.row }"
                  >
                    {{ $t('lang.k_240043') }}
                  </vh-dropdown-item>
                  <vh-dropdown-item
                    v-if="!scope.row.layout || scope.row.layout != 0"
                    :command="{ command: 'record.encrypt', data: scope.row }"
                  >
                    {{ $t('lang.k_240014') }}
                  </vh-dropdown-item>
                  <vh-dropdown-item :command="{ command: 'delete', data: scope.row }">
                    {{ $t('lang.k_240040') }}
                  </vh-dropdown-item>
                </vh-dropdown-menu>
              </vh-dropdown>
              <vh-dropdown
                v-else-if="WEBINAR_PES['webinar.timing'] && liveDetailInfo.is_demand == 1"
                @command="handleCommand"
              >
                <vh-button type="text">{{ $t('lang.k_240041') }}</vh-button>
                <vh-dropdown-menu style="width: 160px" slot="dropdown">
                  <vh-dropdown-item :command="{ command: 'publishVideo', data: scope.row }">
                    {{ $t('lang.k_240043') }}
                  </vh-dropdown-item>
                </vh-dropdown-menu>
              </vh-dropdown>
            </template>
          </vh-table-column>
        </vh-table>
        <SPagination
          :total="totalElement"
          :page-size="pageSize"
          :current-page="pageNum"
          @current-change="currentChangeHandler"
          @size-change="sizeChange"
        ></SPagination>
        <null-page
          :text="$t('lang.k_240044')"
          nullType="search"
          v-if="totalElement === 0"
        ></null-page>
      </div>
    </template>

    <!-- 编辑弹窗 -->
    <vh-dialog
      :title="$t('lang.k_240037')"
      v-loading="editLoading"
      :visible.sync="editDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="480px"
    >
      <vh-form label-width="65px" ref="curEditForm" :model="curEdit" :rules="curEditRules">
        <vh-form-item :label="$t('lang.k_240045')" required>
          <upload
            class="upload__avatar"
            ref="back_cover_uploader"
            v-model="curEdit.img_url"
            :saveData="saveImageData"
            :domain_url="domainUrl"
            :isShowDel="false"
            :on-success="handleUploadSuccess"
            :on-change="handleUploadChange"
            :auto-upload="false"
          >
            <div slot="tip">
              <p>{{ $t('lang.k_240046') }}</p>
              <p>{{ $t('lang.k_240047') }}</p>
            </div>
          </upload>
          <p style="font-size: 12px">{{ $t('lang.k_240048') }}</p>
        </vh-form-item>
        <vh-form-item :label="$t('lang.k_240049')" prop="name">
          <vh-input
            :placeholder="$t('lang.k_240050')"
            :maxlength="100"
            autocomplete="off"
            v-clearEmoij
            :autosize="{ minRows: 3 }"
            resize="none"
            show-word-limit
            v-model="curEdit.name"
            class="input-with-select"
            type="textarea"
          ></vh-input>
        </vh-form-item>
      </vh-form>

      <span slot="footer" class="dialog-footer">
        <vh-button
          type="info"
          @click="editDialogVisible = false"
          :disabled="editLoading"
          round
          plain
          size="medium"
        >
          {{ $t('lang.k_240051') }}
        </vh-button>
        <vh-button type="primary" @click="confirmEdit" :disabled="editLoading" round size="medium">
          {{ $t('lang.k_240052') }}
        </vh-button>
      </span>
    </vh-dialog>

    <!-- 发布弹窗 -->
    <vh-dialog
      :title="$t('lang.k_240053')"
      :visible.sync="publishDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="580px"
    >
      <div class="publish-container">
        <div
          class="item"
          :class="activeIndex == 1 ? 'active' : 'unactive'"
          @click="activeIndex = 1"
        >
          <p class="item-img"><img src="./images/vod@2x.png" alt="" /></p>
          <div class="item-text">
            <p>{{ $t('lang.k_240054') }}</p>
            <span>{{ $t('lang.k_240055') }}</span>
          </div>
        </div>
        <div
          class="item"
          :class="activeIndex == 2 ? 'active' : 'unactive'"
          @click="activeIndex = 2"
        >
          <p class="item-img"><img src="./images/timing@2x.png" alt="" /></p>
          <div class="item-text">
            <p>{{ $t('lang.k_240056') }}</p>
            <span>{{ $t('lang.k_240057') }}</span>
          </div>
        </div>
      </div>
      <div class="dialog-publish-footer">
        <vh-button type="primary" round size="medium" @click="publishVideo">
          {{ $t('lang.k_240058') }}
        </vh-button>
      </div>
    </vh-dialog>
    <!-- 预览功能 -->
    <template v-if="showDialog">
      <vh-dialog
        custom-class="dialog-padding_playbackpreview"
        class="vh-saas-dialog"
        :visible.sync="showDialog"
        width="1010px"
        :before-close="closeBefore"
        center
        :close-on-press-escape="false"
      >
        <video-preview
          ref="videoPreview"
          :recordId="videoParamId"
          :webinarId="webinar_id"
        ></video-preview>
      </vh-dialog>
    </template>
    <begin-play
      :webinarId="$route.params.str"
      v-if="webinarState != 4 && $route.query.type != 5"
    ></begin-play>
    <!-- 上传回放视频 -->
    <PlaybackUpload ref="playbackUpload" @search="getList"></PlaybackUpload>

    <!-- 下载弹窗 -->
    <vh-dialog
      :title="$t('lang.k_240038')"
      :visible.sync="downloadVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="480px"
    >
      <div
        class="download-container"
        :class="{
          'justify-center': downloadData.status != 0,
          h_no_start: downloadData.status == 0
        }"
      >
        <div class="typeLogo">
          <i class="iconfont-v3 saasyinpinwenjian" v-if="[1].includes(webinarType)" />
          <i class="iconfont-v3 saasshipinwenjian" v-if="[2, 3, 6].includes(webinarType)" />
        </div>
        <p class="download_name">{{ downloadData.name }}</p>
        <vh-progress
          class="progress_wid"
          :percentage="downloadData.progress"
          :color="customColorMethod"
          :status="
            downloadData.status == 1
              ? 'success'
              : downloadData.status == 3
              ? 'exception'
              : undefined
          "
          v-if="[1, 2, 3].includes(downloadData.status)"
        ></vh-progress>
        <p
          class="download_progress_tip"
          :class="{ over_color: [1, 3].includes(downloadData.status) }"
          v-if="downloadData.statusText"
        >
          {{ downloadData.statusText }}
        </p>
        <vh-button
          type="primary"
          round
          size="medium"
          @click="transcodingStart"
          v-if="downloadData.status == 0"
        >
          {{ $t('lang.k_240059') }}
        </vh-button>
      </div>

      <div class="dialog-download-footer" :class="{ ing_height: downloadData.status == 2 }">
        <div align="center" v-if="[3].includes(downloadData.status)">
          <vh-button type="primary" round size="medium" @click="transcodingStart">
            {{ $t('lang.k_240059') }}
          </vh-button>
        </div>

        <div align="center" v-if="downloadData.download_url">
          <vh-button type="primary" round size="medium" @click="downloadVideo">
            {{ $t('lang.k_240060') }}
          </vh-button>
        </div>
      </div>
      <div class="download_tip_base" v-if="downloadData.status == 0">
        <p>{{ $t('lang.k_240061') }}</p>
        <p>{{ $t('lang.k_240062') }}</p>
        <p>{{ $t('lang.k_240063') }}</p>
      </div>
    </vh-dialog>
    <!-- 裁剪图片弹窗 -->
    <cropper
      ref="backCropper"
      :currentMode="cropData.currentMode"
      :ratio="16 / 9"
      @cropComplete="cropComplete"
      @resetUpload="resetChooseFile"
    ></cropper>
  </div>
</template>

<script>
  import VideoPreview from './components/previewVideo';
  import PlaybackUpload from './components/playbackUpload';
  import PageTitle from '@/components/PageTitle';
  import cropper from '@/components/Cropper/index';
  import upload from '@/components/Upload/main';
  import {
    sessionOrLocal,
    isEmbed,
    parseQueryString,
    buildUrlByMode,
    buildOssUploadProcessData
  } from '@/utils/utils';
  import NullPage from '../../PlatformModule/Error/nullPage.vue';
  import beginPlay from '@/components/beginBtn';
  import tableCellTooltip from '@/components/TableList/mixins/tableCellTooltip';
  import { formateSeconds } from '@/utils/general';
  import { sizeTostr } from '@/utils/filter';

  export default {
    name: 'PlaybackList',
    mixins: [tableCellTooltip],
    data() {
      return {
        isEmbed: isEmbed(),
        lowerGradeInterval: null,
        // 预览
        showDialog: false,
        webinarState: JSON.parse(sessionOrLocal.get('webinarState')),
        videoParamId: '',
        userId: JSON.parse(sessionOrLocal.get('userId')),
        tableData: [],
        defaultImg: require('../../../common/images/v35-webinar.png'),
        keyWords: '',
        pageSize: 10,
        pageNum: 1,
        loading: false,
        totalElement: 0,
        editDialogVisible: false,
        curEdit: {
          img_url: ''
        }, //当前正在编辑的回放
        cropData: {
          currentMode: 1,
          upload_process_data: ''
        },
        editRecord: {},
        editLoading: false,
        selectDatas: [],
        transcodingArr: [],
        encryptingArr: [],
        recordType: '-1',
        liveDetailInfo: {},
        isDemand: '',
        chatSDK: '',
        handleMsgTimer: '',
        no_show: '',
        typeOptions: [
          { label: this.$t('lang.k_240064'), value: '-1' },
          { label: this.$t('lang.k_240065'), value: '0' },
          { label: this.$t('lang.k_240005'), value: '1' },
          { label: this.$t('lang.k_240006'), value: '2' },
          { label: this.$t('lang.k_240066'), value: '3' }
        ],

        // 权限配置
        WEBINAR_PES: {},
        OLDWEBINAR_PES: {},
        isBidScreen: true,
        versionExpired: false, // 用户套餐是否过期
        publishDialogVisible: false,
        activeIndex: 1, //默认激活点播
        recordData: {}, //发布时数据
        // WEBINAR_PES: sessionOrLocal.get('WEBINAR_PES', 'localStorage') && JSON.parse(sessionOrLocal.get('WEBINAR_PES', 'localStorage')) || {},
        downloadVisible: false,
        downloadData: {},
        curEditRules: {
          name: [{ required: true, message: `${this.$t('lang.k_240067')}`, trigger: 'blur' }]
        }
      };
    },
    computed: {
      domainUrl() {
        if (!this.curEdit.img_url) return '';
        return buildUrlByMode(this.curEdit.img_url, this.currentMode);
      },
      saveImageData() {
        let imageData = {
          path: `/playback/cover/${dayjs().format('YYYYMM')}`,
          type: 'image'
        };
        if (this.cropData.upload_process_data) {
          imageData.process = this.cropData.upload_process_data;
        }
        return imageData;
      },
      pos() {
        return (this.pageNum - 1) * this.pageSize;
      },
      webinar_id() {
        return this.$route.params.str;
      },
      title() {
        if (this.isDemand === '') {
          return '';
        } else if (this.isDemand) {
          return this.liveDetailInfo.webinar_type == 5
            ? this.$t('lang.k_240068')
            : this.$t('lang.k_240069');
        } else {
          return this.$t('lang.k_240070');
        }
      },
      webinarType() {
        return this.liveDetailInfo && this.liveDetailInfo.webinar_type;
      },
      // 显示下载按钮: 如果是子账号还需要有下载权限  点播定时直播需要admin权限
      showDownloadButton() {
        return !(
          ((this.liveDetailInfo.webinar_state == 4 ||
            [5, '5'].includes(this.liveDetailInfo.webinar_type)) &&
            !this.WEBINAR_PES['download_demand']) ||
          (this.childPremission && Number(this.childPremission.permission_content_download) === 0)
        );
      },
      childPremission: function () {
        return sessionOrLocal.get('SAAS_V3_SON_PS')
          ? JSON.parse(sessionOrLocal.get('SAAS_V3_SON_PS'))
          : {};
      }
    },
    created() {
      this.getList();
      this.getLiveDetail();
      this.$EventBus.$on('record_download', this.handleDownload);
      this.$EventBus.$on('vod_download_progress', this.transcodingProgress);
      this.$EventBus.$on('vod_remake_doc_progress', this.docProgress);
      this.$EventBus.$on('encrypt_complete', this.handleEncryptCallback);
      this.getPermission(this.$route.params.str);
      this.getVersion();
    },
    mounted() {
      window.addEventListener('resize', this.calcScreenWidth);

      this.$EventBus.$on('vod_cut', res => {
        //不是自己的消息不处理 || status ==1 剪辑成功
        if (this.userId != res.user_id || res.status != 1) {
          return;
        }
        // 转码状态
        console.log(res, '监听到vod_cut未读消息提示事件');
        this.tableData.map((item, index) => {
          // 0 转码中 1转码成功 2转码失败
          if (res.record_id == item.id) {
            if (res.status == 1) {
              item.transcode_status = 1;
              item.percentage = undefined;
              item.duration = formateSeconds(res.duration);
              item.transcode_status_text = this.$t('lang.k_240071');
              item.storage = res.storage ? sizeTostr(res.storage * 1024) : '--';
            } else {
              item.percentage = undefined;
              item.transcode_status = 2;
              item.duration = '——';
              item.transcode_status_text = this.$t('lang.k_240072');
            }
            this.$nextTick(() => {
              this.$set(this.tableData, index, Object.assign({}, item));
            });
          }
        });
        // this.getTableList();
      });

      this.$EventBus.$on('sign_trans_code', res => {
        //不是自己的消息不处理
        if (this.userId != res.user_id) {
          return;
        }
        // 转码状态
        console.log(res, '监听到sign_trans_code未读消息提示事件');
        this.tableData.map((item, index) => {
          // 0 转码中 1转码成功 2转码失败
          if (res.record_id == item.id) {
            if (res.status == 1) {
              item.transcode_status = 1;
              item.percentage = undefined;
              item.duration = formateSeconds(res.duration);
              item.transcode_status_text = this.$t('lang.k_240071');
              item.storage = res.storage ? sizeTostr(res.storage * 1024) : '--';
            } else if (res.status == 0) {
              item.transcode_status = 0;
              item.percentage = res.progress;
              item.transcode_status_text = this.$t('lang.k_240073');
            } else {
              item.percentage = undefined;
              item.transcode_status = 2;
              item.duration = '——';
              item.transcode_status_text = this.$t('lang.k_240072');
            }
            this.$set(this.tableData, index, Object.assign({}, item));
          }
        });
        // this.getTableList();
      });
    },
    beforeDestroy() {
      if (!this.WEBINAR_PES['forbid_delrecord'] || !this.WEBINAR_PES['publish_record']) {
        this.tipMsg && this.tipMsg.close();
      }
      if (this.chatSDK) {
        this.chatSDK.destroy();
        this.chatSDK = null;
      }
      if (this.lowerGradeInterval) clearInterval(this.lowerGradeInterval);
      this.$EventBus.$off('record_download', this.handleDownload);
      this.$EventBus.$off('vod_download_progress', this.transcodingProgress);
      this.$EventBus.$off('vod_remake_doc_progress', this.docProgress);
      this.$EventBus.$off('encrypt_complete', this.handleEncryptCallback);
      window.removeEventListener('resize', this.calcScreenWidth);
    },
    methods: {
      layoutFilter(layout) {
        if (layout == 0) {
          return '-';
        } else if (layout == 1) {
          return this.$t('lang.k_240113');
        } else if (layout == 2) {
          return this.$t('lang.k_240114');
        } else if (layout == 3) {
          return this.$t('lang.k_240115');
        }
      },
      soruceTotext(val) {
        //   0 回放 1 录制 2 上传 3 打点录制
        val = Number(val);
        let str = val;
        switch (val) {
          case 0:
            str = this.$t('lang.k_240065');
            break;

          case 1:
            str = this.$t('lang.k_240005');
            break;

          case 2:
            str = this.$t('lang.k_240006');
            break;

          case 3:
            str = this.$t('lang.k_240116');
            break;

          default:
            str = val;
            break;
        }
        return str;
      },
      setDisabled(item) {
        if (this.tableData.filter(el => el.is_display == 1).length >= 100) {
          this.$vhMessage.error(this.$t('lang.k_240074'));
          return;
        }
        this.$fetch('playBackSetDisabled', {
          record_id: item.id,
          is_display: item.is_display
        })
          .then(res => {
            if (res.code == 200) {
              this.$vhMessage.success(
                this.$t('lang.k_240075', [
                  item.is_display == 1 ? this.$t('lang.k_240031') : this.$t('lang.k_240032')
                ])
              );
            }
          })
          .catch(res => {
            this.$vhMessage.error(
              res.msg ||
                this.$t('lang.k_240076', [
                  item.is_display == 1 ? this.$t('lang.k_240031') : this.$t('lang.k_240032')
                ])
            );
            item.is_display = item.is_display == 1 ? 0 : 1;
          });
      },
      cropComplete(cropperData, url, mode) {
        this.currentMode = mode;
        if (cropperData) {
          this.cropData.upload_process_data = buildOssUploadProcessData({
            cropperData: cropperData
          });
        } else {
          this.cropData.upload_process_data = '';
        }

        this.$nextTick(() => {
          this.$refs.back_cover_uploader.upload();
        });
      },
      resetChooseFile() {
        this.$refs.back_cover_uploader.resetChooseFile();
      },
      handleUploadSuccess(res, file) {
        if (res.data) {
          this.curEdit.img_url = res.data.domain_url;
        }
      },
      handleUploadChange(file, fileList) {
        if (file.status == 'ready') {
          this.$checkUploadType(file.raw, this, 1, 2, () => {
            let reader = new FileReader();
            reader.readAsDataURL(file.raw);
            reader.onload = e => {
              this.$refs.backCropper.showModel(e.target.result);
            };
          });
        }
      },
      getVersion() {
        this.$fetch('getVersionInfo', { user_id: this.userId })
          .then(res => {
            this.versionExpired = res.data.expired == 1;
          })
          .catch(e => {
            console.log(e);
          });
      },
      calcScreenWidth() {
        const clientWidth = document.body.clientWidth;
        if (this.isDemand) return;
        if (clientWidth < 1900) {
          this.isBidScreen = false;
        } else {
          this.isBidScreen = true;
        }
      },
      handleTipMsgVisible() {
        let that = this;
        if (!this.WEBINAR_PES['forbid_delrecord']) {
          const head = this.WEBINAR_PES['forbid_delrecord']
            ? ''
            : '<span class="msgGray">' + this.$t('lang.k_240077') + '</span>';
          const body =
            !this.WEBINAR_PES['forbid_delrecord'] && !this.WEBINAR_PES['publish_record']
              ? '，'
              : '';
          const end = this.WEBINAR_PES['publish_record']
            ? ''
            : '<span   id="msgBlue">' + this.$t('lang.k_240078') + '</span>';
          this.tipMsg = this.$vhMessage({
            dangerouslyUseHTMLString: true,
            type: 'warning',
            message: `${head}${body}${end}`,
            showClose: true,
            duration: 0
          });
          // let open = document.querySelector('#msgBlue');
          // open &&
          //   open.addEventListener('click', function (e) {
          //     let url = 'https://vhall.s4.udesk.cn/im_client/?web_plugin_id=15038';
          //     that.$vhall_paas_port({
          //       k: 100017,
          //       data: {
          //         business_uid: that.userId,
          //         user_id: '',
          //         webinar_id: that.$route.params.str,
          //         s: '',
          //         refer: 2,
          //         report_extra: {},
          //         ref_url: '',
          //         req_url: ''
          //       }
          //     });
          //     window.open(url, '_blank');
          //   });
        }
      },
      goReportData() {
        this.$vhall_paas_port({
          k: 100017,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: this.$route.params.str,
            s: '',
            refer: 2,
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
      },
      getPermission(id) {
        // 活动权限
        this.$fetch('planFunctionGet', {
          webinar_id: id,
          webinar_user_id: this.userId,
          scene_id: 1
        })
          .then(res => {
            if (res.code == 200) {
              if (res.data.permissions) {
                sessionOrLocal.set('WEBINAR_PES', res.data.permissions, 'localStorage');
                this.WEBINAR_PES = JSON.parse(res.data.permissions);
                console.log('之前旧的权限', this.WEBINAR_PES);
                // this.handleLowerGradeHeart();
              } else {
                sessionOrLocal.removeItem('WEBINAR_PES');
              }
            } else {
              sessionOrLocal.removeItem('WEBINAR_PES');
            }
          })
          .catch(e => {
            console.log(e);
            sessionOrLocal.removeItem('SAAS_VS_PES');
          });
      },
      preview(data) {
        //  this.videoParam 进本信息
        if (data.transcode_status == 1) {
          this.showDialog = true;
          this.videoParamId = data.id;
        } else {
          this.$vhMessage.warning(this.$t('lang.k_240079'));
        }
      },
      reTranscode(data) {
        if (data.transcode_status == 2 && data.layout != 0) {
          this.$vhMessage({
            message: `${this.$t('lang.k_240080')}`,
            showClose: true,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return false;
        }
        this.$fetch('recordReTranscode', {
          paas_record_id: data.paas_record_id,
          webinar_id: this.webinar_id
        }).then(res => {
          this.$vhMessage({
            message: `${this.$t('lang.k_240081')}`,
            showClose: true,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.getList();
        });
      },
      closeBefore(done) {
        // this.$refs.videoPreview.destroy();
        done();
      },
      // 获取当前活动基本信息 判断是点播还是直播回放
      getLiveDetail() {
        // webinar/info调整-与活动状态无关的调用
        this.$fetch('getWebinarInfo', { webinar_id: this.webinar_id })
          .then(res => {
            this.liveDetailInfo = res.data;
            if (this.liveDetailInfo.webinar_type == 5 && !this.liveDetailInfo.is_demand) {
              this.isDemand = true;
            } else {
              this.isDemand = this.liveDetailInfo.is_demand == 1;
            }

            this.calcScreenWidth();
            if (this.isDemand) {
              this.recordType = this.$t('lang.k_240006');
              this.typeOptions = [{ label: this.$t('lang.k_240006'), value: '2' }];
            } else {
              this.handleTipMsgVisible();
              this.typeOptions = [
                { label: this.$t('lang.k_240064'), value: '-1' },
                { label: this.$t('lang.k_240065'), value: '0' },
                { label: this.$t('lang.k_240005'), value: '1' },
                { label: this.$t('lang.k_240006'), value: '2' },
                { label: this.$t('lang.k_240066'), value: '3' }
              ];
            }
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || this.$t('lang.k_240082'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
      typeChange(column, index) {
        this.getList();
      },
      setDefault(row) {
        console.log(row);
        // 判断视频是否为加密中
        if (row.encrypt_status == '1') {
          let msg = this.$t('lang.k_240083');
          this.$vhMessage.warning(msg);
          return;
        }
        const confirmTitle = row.type === 6 ? this.$t('lang.k_240084') : this.$t('lang.k_240085');
        this.$vhConfirm(confirmTitle, this.$t('lang.k_240061'), {
          confirmButtonText: this.$t('lang.k_240052'),
          cancelButtonText: this.$t('lang.k_240051'),
          roundButton: true,
          customClass: 'zdy-message-box',
          lockScroll: false,

          cancelButtonClass: 'zdy-confirm-cancel'
        }).then(() => {
          this.$fetch('defaultRecord', {
            webinar_id: this.webinar_id,
            record_id: row.id,
            type: row.type === 6 ? 0 : 1
          }).then(res => {
            console.log(res);
            // TODO: 刷新列表
            this.getList();
          });
        });
      },
      handleSelectionChange(val) {
        this.selectDatas = val;
      },
      handleCommand(param) {
        // 判断是否为加密视频
        if (
          param.data.encrypt_status == '2' &&
          param.command != 'delete' &&
          param.command != 'record.encrypt'
        ) {
          let msg = this.$t('lang.k_240086');
          this.$vhMessage.warning(msg);
          return;
        }
        // 判断视频是否为加密中
        if (param.data.encrypt_status == '1' && param.command != 'delete') {
          let msg = this.$t('lang.k_240083');
          this.$vhMessage.warning(msg);
          return;
        }
        // 判断视频是否为转码中
        if (!param.data.transcode_status && param.command != 'delete') {
          let msg = this.$t('lang.k_240087');
          this.$vhMessage.warning(msg);
          return;
        }
        if (param.command == 'delete') {
          this.deletePlayBack(param.data.id, 2);
        } else if (param.command == 'tailoring') {
          this.$vhall_paas_port({
            k: 100411,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              s: '',
              refer: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.toTailoring(param.data.id, param.data.name);
        } else if (param.command == 'publish') {
          this.$vhall_paas_port({
            k: 100413,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              s: '',
              refer: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.toCreateDemand(param.data);
        } else if (param.command == 'vodreset') {
          this.$vhall_paas_port({
            k: 100415,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              s: '',
              refer: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.toVodreset(param.data);
        } else if (param.command == 'publishVideo') {
          this.$vhall_paas_port({
            k: 100413,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              s: '',
              refer: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          //发布为定时直播
          this.recordData = param.data;
          this.publishVideoPre(2);
        }
        // 加密按钮
        if (param.command == 'record.encrypt') {
          this.encryption(param.data);
        }
      },
      currentChangeHandler(num) {
        this.pageNum = num;
        this.getList();
      },
      sizeChange(num) {
        this.pageNum = 1;
        this.pageSize = num;
        this.getList();
      },
      getSearchList() {
        if (this.keyWords) {
          this.$vhall_paas_port({
            k: 100418,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              s: '',
              refer: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
        }
        this.getList();
      },
      getList() {
        let param = {
          webinar_id: this.webinar_id,
          user_id: this.userId,
          pos: this.pos,
          limit: this.pageSize,
          source: this.recordType
        };
        param.source == this.$t('lang.k_240006') && (param.source = -1);
        this.keyWords && (param.name = this.keyWords);
        this.loading = true;
        this.$fetch('playBackList', param)
          .then(res => {
            res.data.list.forEach(item => {
              item.transcoding = false;
            });
            this.tableData = res.data.list;
            console.log('this.tableData:', this.tableData);
            this.totalElement = res.data.total;
            if (this.no_show === '') {
              this.no_show = res.data.total == 0 ? true : false;
            }
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || `${this.$t('lang.k_240088')}`,
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          })
          .finally(() => {
            this.loading = false;
          });
        // playBackList
      },
      editDialog(data) {
        this.curEdit = { ...data };
        this.cropData.currentMode = parseQueryString(data.img_url)?.mode || 1;
        this.editDialogVisible = true;
        this.editRecord = data;
      },
      handleEncryptCallback(data) {
        // data
        // 'type'      => 'entry_trans',
        // 'user_id'   => 视频资源对应用户id,
        // 'status'    => 1 成功 2:失败,
        // 'record_id' => 视频资源id
        console.log('视频加密完成');
        this.encryptingArr = this.encryptingArr.filter(item => {
          if (item.id == data.record_id) {
            item.encrypt_status = '2';
            return false;
          }
        });
      },
      handleDownload(data) {
        console.log('视频转码完成了');
        // 消息会下发三次，只处理第一次
        if (!this.handleMsgTimer) {
          this.transcodingArr = this.transcodingArr.filter(item => {
            if (item.id == data.record_id) {
              item.transcoding = false;
              return false;
            }
          });
          if (data.record_id == this.downloadData.record_id) {
            this.downloadData.status = data.status;
            if (data.status == 3) {
              this.downloadData.statusText = this.$t('lang.k_240089');
            }
            if (data.download_url) {
              this.downloadData.progress = 100;
              this.downloadData.download_url = data.download_url;
              this.downloadData.statusText = this.$t('lang.k_240090');
            }
            console.log(this.downloadData, 'this.downloadData');
            this.$forceUpdate();
          }
          // window.open(data.download_url);
          this.handleMsgTimer = setTimeout(() => {
            this.handleMsgTimer = '';
          }, 2000);
        }
      },
      // 下载回放
      downPlayBack(data) {
        // 判断视频是否为加密中
        if (data.encrypt_status == '1') {
          let msg = this.$t('lang.k_240083');
          this.$vhMessage.warning(msg);
          return;
        }
        if (this.versionExpired) {
          this.$vhConfirm(
            this.$t('lang.k_240091'),
            this.$t('lang.k_240061'),

            {
              confirmButtonText: this.$t('lang.k_240092'),
              showCancelButton: false,
              roundButton: true,
              customClass: 'zdy-message-box',
              lockScroll: false,

              cancelButtonClass: 'zdy-confirm-cancel'
            }
          )
            .then(() => {})
            .catch(() => {});
          return false;
        }

        // const fetchCb = () => {
        //   this.$fetch('playBackDownUrlGet', {
        //     record_id: data.id
        //   }).then(res => {
        //     console.log(res);
        //     this.$vhall_paas_port({
        //       k: 100409,
        //       data: {
        //         business_uid: this.userId,
        //         user_id: '',
        //         webinar_id: this.$route.params.str,
        //         s: '',
        //         refer: '',
        //         report_extra: {},
        //         ref_url: '',
        //         req_url: ''
        //       }
        //     });
        //     if (res.data.has_download_url == 0) {
        //       data.transcoding = true;
        //       this.transcodingArr.push(data);
        //       this.$vhMessage({
        //         message: `正在生成，请稍侯...`,
        //         showClose: true,
        //         // duration: 0,
        //         type: 'success',
        //         customClass: 'zdy-info-box'
        //       });
        //       return false;
        //     }
        //     window.open(res.data.download_url);
        //   });
        // };
        this.checkTransStatus(data.id, this.getVideoStatus);
      },
      deletePlayBack(ids, index) {
        this.$vhConfirm(
          this.$t('lang.k_240093'),
          this.$t('lang.k_240061'),

          {
            confirmButtonText: this.$t('lang.k_240052'),
            cancelButtonText: this.$t('lang.k_240051'),
            roundButton: true,
            customClass: 'zdy-message-box',
            lockScroll: false,

            cancelButtonClass: 'zdy-confirm-cancel'
          }
        )
          .then(() => {
            this.loading = true;
            this.$fetch('playBackDelete', { record_ids: ids })
              .then(res => {
                this.$vhall_paas_port({
                  k: index === 1 ? 100416 : 100417,
                  data: {
                    business_uid: this.userId,
                    user_id: '',
                    webinar_id: this.$route.params.str,
                    s: '',
                    refer: '',
                    report_extra: {},
                    ref_url: '',
                    req_url: ''
                  }
                });
                this.$vhMessage({
                  message: `${this.$t('lang.k_240094')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
                this.getList();
              })
              .catch(res => {
                this.$vhMessage({
                  message: res.msg || `${this.$t('lang.k_240095')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'error',
                  customClass: 'zdy-info-box'
                });
                this.loading = false;
              });
          })
          .catch(() => {});
      },
      confirmEdit() {
        this.$refs.curEditForm.validate(flag => {
          if (flag) {
            this.editLoading = true;
            this.$fetch('playBackEdit', {
              record_id: this.editRecord.id,
              name: this.curEdit.name,
              img_url: this.domainUrl
            })
              .then(res => {
                this.$vhall_paas_port({
                  k: 100408,
                  data: {
                    business_uid: this.userId,
                    user_id: '',
                    webinar_id: this.$route.params.str,
                    s: '',
                    refer: '',
                    report_extra: {},
                    ref_url: '',
                    req_url: ''
                  }
                });
                this.$vhMessage({
                  message: `${this.$t('lang.k_240096')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
                this.getList();
                this.editDialogVisible = false;
              })
              .catch(res => {
                this.$vhMessage({
                  message: res.msg || `${this.$t('lang.k_240097')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'error',
                  customClass: 'zdy-info-box'
                });
              })
              .finally(() => {
                this.editLoading = false;
              });
          }
        });
      },
      settingHandler() {
        this.$vhall_paas_port({
          k: 100407,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: this.$route.params.str,
            s: '',
            refer: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        this.$router.push({
          path: `${this.isEmbed ? '/embed' : ''}/live/planFunction/${this.webinar_id}`
        });
      },
      toVodreset(data) {
        if (this.versionExpired) {
          this.$vhConfirm(
            this.$t('lang.k_240091'),
            this.$t('lang.k_240061'),

            {
              confirmButtonText: this.$t('lang.k_240092'),
              // cancelButtonText: '暂不关闭',
              showCancelButton: false,
              roundButton: true,
              customClass: 'zdy-message-box',
              lockScroll: false,

              cancelButtonClass: 'zdy-confirm-cancel'
            }
          )
            .then(() => {})
            .catch(() => {});
          return false;
        }
        const routerPush = () => {
          this.$router.push({
            path: `${this.isEmbed ? '/embed' : ''}/live/vodreset/${this.webinar_id}`,
            query: {
              record_id: data.id
            }
          });
        };
        this.checkTransStatus(data.id, routerPush);
      },
      toCreate() {
        this.$router.push({
          path: `/videoTailoring/${this.webinar_id}`,
          query: {
            from: this.isEmbed ? 'embed' : ''
          }
        });
        // const routeData = this.$router.resolve({path: `/videoTailoring/${this.webinar_id}`});
        // window.open(routeData.href, '_blank');
      },
      toRecord() {
        this.$fetch('recordCheck', {
          webinar_id: this.webinar_id
        })
          .then(res => {
            if (res.code == 200) {
              // this.$router.push({path: `/live/recordvideo/${this.webinar_id}`});
              window.location.href = `${window.location.origin}${process.env.VUE_APP_WEB_KEY}/lives/recordvideo/${this.webinar_id}`;
            }
          })
          .catch(err => {
            if (err.code == 512550) {
              this.$vhMessage.warning(this.$t('lang.k_240098'));
            } else {
              this.$vhMessage.warning(err.msg);
            }
          });
      },
      toTailoring(recordId, recordName) {
        const routerPush = () => {
          this.$router.push({
            path: `/videoTailoring/${this.webinar_id}`,
            query: { recordId, recordName, from: this.isEmbed ? 'embed' : '' }
          });
        };
        this.checkTransStatus(recordId, routerPush);
      },
      checkTransStatus(recordId, cb) {
        this.$fetch('recordInfo', {
          record_id: recordId
        }).then(res => {
          if (res.data.transcode_status == 0 || res.data.transcode_status == 3) {
            this.$vhMessage({
              message: this.$t('lang.k_240099'),
              showClose: true, // 是否展示关闭按钮
              type: 'warning', //  提示类型
              customClass: 'zdy-info-box' // 样式处理
            });
          } else if (res.data.transcode_status == 2) {
            this.$vhMessage({
              message: this.$t('lang.k_240100'),
              showClose: true, // 是否展示关闭按钮
              type: 'error', //  提示类型
              customClass: 'zdy-info-box' // 样式处理
            });
          } else {
            cb && cb();
          }
        });
      },
      async toChapter(row) {
        // 判断视频是否为加密中
        if (row.encrypt_status == '1') {
          let msg = this.$t('lang.k_240083');
          this.$vhMessage.warning(msg);
          return;
        }
        this.$vhall_paas_port({
          k: 100410,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: this.$route.params.str,
            s: '',
            refer: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        const recordId = row.id;
        const chapterType = this.isDemand ? 'recordchapter' : 'chapter';
        // 如果回放转码完成，并且支持章节功能或者是点播活动，直接跳转
        if (this.isDemand || (row.transcode_status == 1 && row.doc_status)) {
          await this.checkChapterSave(recordId, chapterType);
          return false;
        }
        // 如果是上传音视频
        if (row.source == 2) {
          this.$router.push({
            path: `/${chapterType}/${this.webinar_id}`,
            query: {
              recordId,
              isDemand: true,
              pageKey: this.$route.meta.name,
              type: this.liveDetailInfo.webinar_type,
              from: this.isEmbed ? 'embed' : ''
            }
          });
          return;
        }
        // 如果回放未转码完成，点击的时候需要获取最新的转码状态和是否支持章节功能
        this.$fetch('recordInfo', {
          record_id: recordId
        }).then(res => {
          if (res.data.transcode_status == 0 || res.data.transcode_status == 3) {
            this.$vhMessage({
              message: this.$t('lang.k_240101'),
              showClose: true, // 是否展示关闭按钮
              type: 'warning', //  提示类型
              customClass: 'zdy-info-box' // 样式处理
            });
          } else if (res.data.transcode_status == 2) {
            this.$vhMessage({
              message: this.$t('lang.k_240100'),
              showClose: true, // 是否展示关闭按钮
              type: 'error', //  提示类型
              customClass: 'zdy-info-box' // 样式处理
            });
          } else {
            this.$fetch('getDocInfo', {
              record_id: recordId
            }).then(res => {
              console.log(res);
              if (res.data.doc_titles.length) {
                this.checkChapterSave(recordId, chapterType);
              } else {
                this.$vhMessage({
                  message: this.$t('lang.k_240102'),
                  showClose: true, // 是否展示关闭按钮
                  type: 'warning', //  提示类型
                  customClass: 'zdy-info-box' // 样式处理
                });
              }
            });
          }
        });
      },
      checkChapterSave(recordId, chapterType) {
        return this.$fetch('checkChapterSave', {
          record_id: recordId
        }).then(res => {
          if (res.data && res.data.chatper_callbanck_status == 0) {
            this.$vhMessage({
              message: this.$t('lang.k_240103'),
              showClose: true, // 是否展示关闭按钮
              type: 'warning', //  提示类型
              customClass: 'zdy-info-box' // 样式处理
            });
          } else {
            this.$router.push({
              path: `/${chapterType}/${this.webinar_id}`,
              query: {
                recordId,
                isDemand: this.isDemand,
                pageKey: this.$route.meta.name,
                type: this.liveDetailInfo.webinar_type,
                from: this.isEmbed ? 'embed' : ''
              }
            });
            // const routeData = this.$router.resolve({path: `/${chapterType}/${this.webinar_id}`, query: {recordId, isDemand: this.isDemand}});
            // window.open(routeData.href, '_blank');
          }
        });
      },
      // 发布
      toCreateDemand(recordData) {
        this.recordData = recordData;
        if (this.WEBINAR_PES['webinar.timing'] == 1) {
          this.publishDialogVisible = true;
        } else {
          this.publishVodTiming(recordData, 1);
        }
      },

      // 发布为点播或定时直播
      publishVodTiming(recordData, index) {
        const url = index == 1 ? '/live/vodEdit' : '/live/timeEdit';
        const routerPush = () => {
          this.$router.push({
            path: `${this.isEmbed ? '/embed' : ''}${url}`,
            query: {
              record_id: recordData.id,
              paas_record_id: recordData.paas_record_id,
              name: recordData.name,
              webinar_id: this.webinar_id
            }
          });
        };
        this.checkTransStatus(recordData.id, routerPush);
      },
      publishVideo() {
        this.publishDialogVisible = false;
        this.publishVodTiming(this.recordData, this.activeIndex);
      },
      // 加密
      encryption(data) {
        // 判断视频是否为转码失败
        if (data.transcode_status == '2') {
          let msg = this.$t('lang.k_240104');
          this.$vhMessage.warning(msg);
          return;
        }
        // 判断是否有加密权限
        if (this.WEBINAR_PES['record.encrypt'] != 1) {
          this.$vhConfirm(
            this.$t('lang.k_240105'),
            this.$t('lang.k_240061'),

            {
              confirmButtonText: this.$t('lang.k_240092'),
              showCancelButton: false,
              roundButton: true,
              customClass: 'zdy-message-box',
              lockScroll: false,

              cancelButtonClass: 'zdy-confirm-cancel'
            }
          )
            .then(() => {})
            .catch(() => {});
          return false;
        }
        // 判断视频是否已加密
        if (data.encrypt_status == '2') {
          let msg = this.$t('lang.k_240106');
          this.$vhMessage.warning(msg);
          return;
        }
        // 判断视频是否为加密中
        if (data.encrypt_status == '1') {
          let msg = this.$t('lang.k_240083');
          this.$vhMessage.warning(msg);
          return;
        }
        this.$vhConfirm(
          this.$t('lang.k_240107'),
          this.$t('lang.k_240061'),

          {
            confirmButtonText: this.$t('lang.k_240052'),
            cancelButton: this.$t('lang.k_240051'),
            customClass: 'zdy-message-box',
            lockScroll: false,
            roundButton: true,

            cancelButtonClass: 'zdy-confirm-cancel'
          }
        )
          .then(() => {
            this.$fetch('checkChapterSave', {
              record_id: data.id
            }).then(res => {
              if (res.data && res.data.chatper_callbanck_status == 0) {
                this.$vhMessage({
                  message: this.$t('lang.k_240103'),
                  showClose: true, // 是否展示关闭按钮
                  type: 'warning', //  提示类型
                  customClass: 'zdy-info-box' // 样式处理
                });
              } else {
                this.encrypyStart(data);
              }
            });
          })
          .catch(() => {});
      },
      encrypyStart(data) {
        this.$fetch('recordEncrypt', {
          paas_record_id: data.paas_record_id
        }).then(res => {
          if (res.code == 200) {
            data.encrypt_status = '1';
            this.encryptingArr.push(data);
          }
        });
      },
      // 加密介绍
      openTip() {
        window.open('https://saas-doc.vhall.com/opendocs/show/1382');
      },
      // 上传音视频
      uploadBut() {
        if (!this.checkVersionExpired()) {
          return false;
        }
        this.$refs['playbackUpload'].dialogVisible = true;
        this.$refs['playbackUpload'].getSearchList('search');
      },
      // 获取视频状态
      getVideoStatus(data) {
        if (!this.checkVersionExpired()) {
          return false;
        }
        this.$fetch('playBackDownUrlGet', {
          record_id: data.id
        }).then(res => {
          console.log(res);
          this.$vhall_paas_port({
            k: 100409,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              s: '',
              refer: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          // if (res.data.has_download_url == 0) {
          //   data.transcoding = true;
          //   this.transcodingArr.push(data);
          //   this.$vhMessage({
          //     message: `正在生成，请稍侯...`,
          //     showClose: true,
          //     // duration: 0,
          //     type: 'success',
          //     customClass: 'zdy-info-box'
          //   });
          //   return false;
          // }
          // window.open(res.data.download_url);
          this.downloadData = {};
          Object.assign(this.downloadData, data, res.data);
          this.openDownload();
        });
      },
      // open download弹框
      openDownload(data) {
        this.downloadVisible = true;
        if (this.downloadData.download_url) {
          this.downloadData.statusText = this.$t('lang.k_240090');
        }
        if (this.downloadData.status == 2) {
          this.downloadData.statusText = this.$t('lang.k_240108');
        }
        if (this.downloadData.status == 3) {
          this.downloadData.statusText = this.$t('lang.k_240089');
        }
      },
      // 开始转码
      transcodingStart() {
        this.downloadData.status = '';
        this.downloadData.statusText = this.$t('lang.k_240108');

        this.$fetch('transBegin', {
          record_id: this.downloadData.record_id
        }).then(res => {
          this.downloadData.status = 2;
          this.$forceUpdate();
        });
      },
      // 转码进度监听
      transcodingProgress(data) {
        if (data.record_id == this.downloadData.record_id) {
          this.downloadData.progress = Number(data.progress);
          if (data.progress == 100) {
            this.downloadData.statusText = this.$t('lang.k_240090');
          }
          this.$forceUpdate();
        }
      },
      // 重置进度监听
      docProgress(data) {
        this.tableData.forEach((i, index) => {
          if (i.id == data.record_id) {
            i.remake_doc_progress = data.progress;
            if (data.progress == 100) {
              i.transcode_status = 1;
            }
          }
        });
      },
      // 进度条颜色更改
      customColorMethod(percentage) {
        if (percentage < 99) {
          return '#FB2626';
        } else {
          return '#0FBA5A';
        }
      },
      // 视频下载
      downloadVideo() {
        window.open(this.downloadData.download_url);
      },
      publishVideoPre(index) {
        this.publishVodTiming(this.recordData, index);
      },
      handleAi(row) {
        console.log('row:', row);
        if (row.transcode_status != 1) {
          this.$vhMessage.warning(this.$t('lang.k_240109'));
          return false;
        }
        if (row.encrypt_status == 1) {
          this.$vhMessage.warning(this.$t('lang.k_240083'));
          return false;
        }
        if (this.WEBINAR_PES['ai_creation'] !== 1) {
          const message =
            this.$t('lang.k_240110') +
            '<br><div class="alert-link "><a class="blue" target="_blank" href="https://saas-doc.vhall.com/opendocs/show/1614">' +
            this.$t('lang.k_240111') +
            '</a></div>';
          this.$vhAlert(
            // `AI创作为收费功能。请联系您的客户经理或专属售后，也可拨打400-888-9970转2咨询。
            //  <br><div class="alert-link "><a class="blue" target="_blank" href="https://saas-doc.vhall.com/opendocs/show/1614">查看功能介绍</a>
            //  &nbsp;&nbsp;&nbsp;<a class="blue" target="_blank" href="https://vhall.s4.udesk.cn/im_client/?web_plugin_id=15038">咨询在线客服</a></div>`,
            message,
            this.$t('lang.k_240061'),

            {
              confirmButtonText: this.$t('lang.k_240092'),
              confirmButtonClass: 'is-round',
              customClass: 'zdy-alert-box zdy-padding',
              dangerouslyUseHTMLString: true,
              // center: true,
              lockScroll: false,
              callback: () => {}
            }
          );
          return false;
        }
        if (!this.checkVersionExpired()) {
          return false;
        }
        if ((window.location.origin || '').indexOf('localhost') > -1) {
          const token = sessionOrLocal.get('token', 'localStorage') || '';
          /* prettier-ignore */
          window.open(`${window.domainOfConsole()}/saas-web-ai/video/parsing/${row.id}?token=${token}`, '_blank');
        } else {
          /* prettier-ignore */
          window.open(`${window.location.origin}/v3/saas-web-ai/video/parsing/${row.id}`, '_blank');
        }
      },
      checkVersionExpired() {
        if (this.versionExpired) {
          this.$vhAlert(
            // '尊敬的用户，您的账号已到期。为了保证正常使用，请联系您的客户经理或专属售后，也可拨打400-888-9970转2咨询。&nbsp;&nbsp;<a class="blue" target="_blank" href="https://vhall.s4.udesk.cn/im_client/?web_plugin_id=15038">在线客服</a>',
            this.$t('lang.k_240112'),
            this.$t('lang.k_240061'),

            {
              confirmButtonText: this.$t('lang.k_240092'),
              confirmButtonClass: 'is-round',
              customClass: 'zdy-alert-box zdy-padding',
              dangerouslyUseHTMLString: true,
              // center: true,
              lockScroll: false,
              callback: () => {}
            }
          );
          return false;
        }
        return true;
      }
    },
    filters: {
      secondsFormmat(val) {
        val = Number(val);
        if (isNaN(val)) return val;
        const hours = parseInt(val / 3600);
        const minutes = parseInt(val / 60) - hours * 60;
        const seconds = val % 60;
        return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}:${
          seconds < 10 ? `0${seconds}` : seconds
        }`;
      }
    },
    components: {
      PageTitle,
      VideoPreview,
      NullPage,
      beginPlay,
      PlaybackUpload,
      cropper,
      upload
    }
  };
</script>

<style lang="less" scoped>
  .listBox {
    .btn-list .vh-button:last-child {
      margin-right: 0;
      margin-left: 0;
    }
    min-width: 1020px;
    .noData .createBtn {
      margin-right: 12px;
    }
  }
  .tableBox {
    padding: 24px 24px;
    background: #fff;
    /deep/ .deltime .cell {
      padding-left: 22px;
    }
    /deep/ .vh-table__empty-block {
      display: none;
    }
    /deep/ .cell {
      color: #666;
    }
    /deep/ .vh-table__row td:nth-child(2) .cell {
      padding-left: 10px;
    }
    /deep/&.recordTableBox .vh-table__row td:nth-child(3) .cell {
      padding-left: 10px;
    }
    /deep/ thead th:nth-child(2) .cell {
      padding-left: 10px;
    }
    /deep/&.recordTableBox thead th:nth-child(3) .cell {
      padding-left: 10px;
    }
    .vh-table {
      margin-bottom: 40px;
    }
    .playpackSource {
      color: #1a1a1a;
    }
    .vh-button.is-disabled {
      border: 0;
      color: #1a1a1a;
    }
    /deep/ thead .vh-select {
      .vh-input__inner {
        border: none;
        color: #666;
      }
      .vh-input__suffix {
        .vh-icon-arrow-up {
          color: #666;
          line-height: 36px;
          // height: 14px;
        }
      }
    }
  }
  /* /deep/ .vh-table__header{
    th{
      background: #F7F7F7;
    }
  } */
  .vh-dropdown {
    margin-left: 10px;
  }
  .content {
    .imageBox {
      position: relative;
      float: left;
      width: 140px;
      height: 79px;
      border-radius: 4px;
      background-color: #1a1a1a;
      .imageWrap {
        width: 100%;
        height: 100%;
        cursor: not-allowed;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 2;
        border-radius: 4px;
        .statusDesc {
          width: 80px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #fff;
          font-size: 12px;
          background: #fb3a32;
          border-radius: 15px;
          cursor: pointer;
          &.disabled {
            cursor: default;
          }
        }
      }
      .defaultSign {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 80px;
        height: 22px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 12px 0px 4px 0px;
        color: #fff;
        font-size: 12px;
        padding-left: 8px;
        &.isRehearsal {
          padding-left: 6px;
          padding-right: 6px;
          width: auto;
        }
        i {
          display: inline-block;
          width: 12px;
          height: 12px;
          border-radius: 8px;
          border: 1px solid #ffffff;
          margin-right: 4px;
          margin-bottom: -2px;
          cursor: pointer;
          &.active {
            border: 3px solid #fb3a32;
            background: #fff;
          }
        }
        // opacity: 0.66;
      }
      .image-slot img {
        cursor: pointer;
      }
    }
    .info {
      margin-left: 12px;
      font-size: 14px;
      width: 187px;
      color: #1a1a1a;
      float: left;
      .name {
        line-height: 20px;
        // height: 40px;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
        -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
        -webkit-line-clamp: 1; /** 显示的行数 **/
        overflow: hidden; /** 隐藏超出的内容 **/
      }
      .create-time {
        padding-top: 5px;
      }
      .tag {
        display: inline-block;
        padding: 0 8px;
        height: 20px;
        line-height: 20px;
        background: #ebefff;
        border-radius: 14px;
        font-size: 12px;
        text-align: center;
        color: #3562fa;
        margin-right: 5px;
      }
    }
    img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      object-fit: scale-down;
    }
  }
  .operaBlock {
    margin-bottom: 20px;
    .vh-input {
      width: 220px;
      float: right;
      /deep/ .vh-input__inner {
        border-radius: 20px;
        height: 36px;
      }
      /deep/ .vh-input__prefix {
        cursor: pointer;
        /deep/ .vh-input__icon {
          line-height: 36px;
        }
      }
    }
    .resetRightBrn {
      /deep/ .vh-input__inner {
        border-radius: 20px;
        height: 36px;
        padding-right: 30px !important;
      }
      /deep/ .vh-input__icon {
        line-height: 36px;
      }
      /deep/ .vh-input__prefix {
        cursor: pointer;
      }
    }
  }
  .input-with-select {
    vertical-align: text-top;
  }
  /deep/ .dialog-padding_playbackpreview {
    padding: 0px 0px 30px;
    background: transparent !important;
    border: none;
    box-shadow: none;
    .vh-dialog__headerbtn {
      top: 24px;
      margin-bottom: 8px;
      .vh-dialog__close {
        color: #ffffff;
      }
    }
  }
  .ps {
    position: absolute;
  }
  .jiami {
    text-align: center;
    font-size: 12px;
    color: white;
    width: 40px;
    height: 22px;
    background: #fb3a32;
    border-radius: 4px 0px 12px 2px;
    top: 0;
    left: 0;
  }
  .jiamizhong {
    text-align: center;
    // font-size: 12px;
    color: white;
    width: 72px;
    height: 23px;
    background: #fb3a32;
    border-radius: 12px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .color999 {
    color: #999;
    font-size: 14px;
  }
  .jiami_zhezhao {
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 4px;
  }
  .publish-container {
    padding: 0 40px;
    display: flex;
    flex-direction: column;
    .item {
      display: flex;
      padding: 28px 32px;
      border-radius: 4px;
      align-items: center;
      border: 1px solid transparent;
      &-img {
        width: 42px;
        height: 36px;
        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
        }
      }
      &-text {
        padding-left: 10px;
        p {
          color: #1a1a1a;
          font-size: 16px;
          line-height: 25px;
        }
        span {
          color: #666;
          font-size: 14px;
          line-height: 20px;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
        }
      }
      &:first-child {
        margin-bottom: 24px;
      }
      &.active {
        border: 1px solid #fb3a32;
      }
      &.unactive {
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
      }
      &:hover {
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
      }
    }
  }
  .dialog-publish-footer {
    padding: 32px 0;
    text-align: center;
  }
  .download_tip_base {
    width: 420px;
    text-align: left;
    margin: auto;
    color: #8c8c8c;
    font-size: 12px;
    line-height: 18px;
    p {
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    }
  }
  .justify-center {
    justify-content: center;
  }
  .download-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 186px;
    .typeLogo {
      margin-bottom: 8px;
      text-align: center;
      i {
        font-size: 40px;
        color: #10d3a8;
      }
      .saasshipinwenjian {
        color: #ff733c;
      }
    }
    p {
      width: 260px;
      margin: 0 auto;
      text-align: center;
      line-height: 20px;
    }
    .download_name {
      margin-bottom: 18px;
      overflow: hidden;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      color: #1a1a1a;
    }
    .progress_wid {
      width: 340px;
      margin-left: 15px;
      // /deep/.vh-progress-bar {
      //   padding-right: 20px;
      //   margin-right: -24px;
      // }
    }
    .download_progress_tip {
      width: 270px;
      margin-top: 10px;
      font-size: 12px;
      color: #8c8c8c;
    }
    .over_color {
      color: #262626;
    }
  }
  .h_no_start {
    height: 168px;
  }
  .ing_height {
    height: 36px;
  }
  .dialog-download-footer {
    text-align: center;
  }
</style>
<style lang="less">
  .alert-link {
    margin-top: 8px;
  }
  .blue {
    color: #3562fa;
    &:hover {
      cursor: pointer;
    }
  }
  .playback-list-popper {
    width: 120px;
  }
  .msgGray {
    color: #1a1a1a;
  }
  .msgBlue {
    color: #3562fa;
    cursor: pointer;
  }
  .vh-tooltip__popper {
    max-width: 376px;
  }
</style>
